










































import { Component, Prop, Vue } from 'vue-property-decorator';

import { MmCreateTaskResponse } from '../../types/dto';
import { MmTask } from '../../types/domain';
import { MmTaskType } from '../../types/enums';
import {
	findBatchOfTask,
	groupTasksIntoBatches,
	MmMonitoringBatch,
} from '../results/batch';
import TaskCard from './TaskCard.vue';
import TaskCreateModal from './TaskCreateModal.vue';
import TasksList from './TasksList.vue';
import { hasTaskCreateDraft, peekTaskCreateDraftType } from './taskCreateDraft';

type MmTasksView = 'list' | 'card';

@Component({
	components: { TaskCard, TaskCreateModal, TasksList },
})
export default class TasksSection extends Vue {
	@Prop({ default: null }) readonly tradingId!: number | null;

	/** Проп объявлен, хотя не используется: иначе он осел бы в $attrs и уехал атрибутом в DOM */
	@Prop({ default: '' }) readonly tradingName!: string;

	/** ant-design-vue 1.7.8 не размонтирует открытую вкладку, поэтому запросы идут только при isActive */
	@Prop({ default: false }) readonly isActive!: boolean;

	view: MmTasksView = 'list';

	isCreateVisible: boolean = false;

	createType: MmTaskType | null = null;

	openTaskId: string | null = null;

	cardInitialTab: string = '';

	deepLinkResultId: string | null = null;

	deepLinkClassificationId: string | null = null;

	/** Снимок соседей берём при открытии: $refs не реактивен, геттер поверх него не пересчитался бы */
	neighbourIds: string[] = [];

	openMonitoringBatch: MmMonitoringBatch | null = null;

	created(): void {
		if (hasTaskCreateDraft(this.tradingId)) {
			this.createType = peekTaskCreateDraftType(this.tradingId);
			this.isCreateVisible = true;
		}
	}

	openCreate(type?: MmTaskType | null): void {
		this.createType = type !== undefined && type !== null ? type : null;
		this.isCreateVisible = true;
	}

	/** Тип не обнуляем при закрытии: окно живёт всю анимацию ухода и успело бы показать пустую форму */
	closeCreate(): void {
		this.isCreateVisible = false;
	}

	handleCreated(response: MmCreateTaskResponse | null): void {
		// createType не сбрасываем: закрывающемуся окну это сменило бы ширину, заголовок и ключ
		this.isCreateVisible = false;

		this.$nextTick(() => {
			const list = this.$refs.list as any;

			if (!list || typeof list.reloadAfterCreate !== 'function') {
				return;
			}

			const ids = response && response.createdTaskIds ? response.createdTaskIds : null;
			const count = response && typeof response.createdCount === 'number'
				? response.createdCount
				: (ids !== null ? ids.length : 0);

			list.reloadAfterCreate(ids, count);
		});
	}

	openCard(taskId: string): void {
		if (!taskId) {
			return;
		}

		if (this.view === 'list') {
			this.captureNeighbours();
		}

		this.openMonitoringBatch = this.readMonitoringBatch(taskId);

		this.clearDeepLink();

		this.openTaskId = taskId;
		this.view = 'card';
	}

	/** Идентификаторы ставим после openCard: он гасит подсветку */
	openTaskResult(
		taskId: string,
		tab: string | null,
		resultId: string | null,
		classificationId: string | null,
	): void {
		if (!taskId) {
			return;
		}

		this.openCard(taskId);

		this.cardInitialTab = tab ? String(tab) : 'results';
		this.deepLinkResultId = resultId ? String(resultId) : null;
		this.deepLinkClassificationId = classificationId ? String(classificationId) : null;
	}

	private clearDeepLink(): void {
		this.deepLinkResultId = null;
		this.deepLinkClassificationId = null;
	}

	closeCard(): void {
		this.view = 'list';
		this.openTaskId = null;
		this.openMonitoringBatch = null;
		this.clearDeepLink();
	}

	handleCardTabChange(tab: string): void {
		this.cardInitialTab = tab ? tab : '';
	}

	handleGoToBatch(payload: { batchId: string | null; taskId: string | null }): void {
		const batchId = payload && payload.batchId ? payload.batchId : null;
		const taskId = payload && payload.taskId ? payload.taskId : null;

		this.closeCard();

		this.$nextTick(() => {
			this.$emit('go-to-monitoring-results', { batchId, taskId });
		});
	}

	private captureNeighbours(): void {
		const list = this.$refs.list as any;
		const rows = list && list.rows ? list.rows : [];
		const ids: string[] = [];

		for (let i = 0; i < rows.length; i += 1) {
			if (rows[i] && rows[i].id) {
				ids.push(rows[i].id);
			}
		}

		this.neighbourIds = ids;
	}

	private readMonitoringBatch(taskId: string): MmMonitoringBatch | null {
		const list = this.$refs.list as any;
		const rows: MmTask[] = list && list.rows ? list.rows : [];

		if (!rows || rows.length === 0) {
			return null;
		}

		return findBatchOfTask(groupTasksIntoBatches(rows), taskId);
	}

	private get currentIndex(): number {
		if (this.openTaskId === null) {
			return -1;
		}

		return this.neighbourIds.indexOf(this.openTaskId);
	}

	get prevTaskId(): string | null {
		const index = this.currentIndex;

		return index > 0 ? this.neighbourIds[index - 1] : null;
	}

	get nextTaskId(): string | null {
		const index = this.currentIndex;

		return index >= 0 && index < this.neighbourIds.length - 1
			? this.neighbourIds[index + 1]
			: null;
	}

	handleGoToAssignments(): void {
		this.$emit('go-to-assignments');
	}
}
